module.exports = __webpack_public_path__ + "img/59.325e4475.png";